import Vue from 'vue';
import AskLisa from './components/ask-lisa';
import Domain from './components/domain';
import Product from './components/product';
import BuyLinks from './components/buy-links';
import AppHeader from './components/app-header';
import GlobalModal from './components/global-modal';

let domain = new Domain();
let appHeader = new AppHeader();
let product = new Product();
let buyLinks = new BuyLinks();
let globalModal = new GlobalModal();

/**
 * A globally available EventBus object that we can use to pass data from algolia to our ask-lisa component.
 */
window.EventBus = new Vue();

/**
 * Start our Ask Lisa app
 */
new Vue({
    el: '#ask-lisa',
});

/**
 * Start our Tips & Advice app
 */
if(document.querySelector('#tips-and-advice'))
{
    new Vue({
        el: '#tips-and-advice',
    });
}

// Utility function so we know when the page has finished loading
jQuery(document).ready(function(){
    document.body.className += " loaded";
});